export enum CTASource {
    STICKY = 'sticky',
    TICKET = 'ticket',
}
